import { FILE_CHUNK_SIZE } from "@common/model/data";
import { CoursewareResourceType } from "@common/model/enum";
import { UploadFormData } from "@common/model/interface";
import { formatSize } from "@common/utils/formatFileSize";
import { GlobalOnlyUploadService } from "@common/service/data-service/upload";

export class ResourceService {
  static getImgWH(url): Promise<{ width: number; height: number }> {
    return new Promise(resolve => {
      const img = new Image();
      // 改变图片的src
      img.src = url;
      const option = {
        width: 0,
        height: 0
      };
      // 判断是否有缓存
      if (img.complete) {
        option.width = img.width;
        option.height = img.height;
        resolve(option);
      } else {
        // 加载完成执行
        img.onload = () => {
          option.width = img.width;
          option.height = img.height;
          resolve(option);
        };
      }
    });
  }
  static getTotalChunkSize(file: File): number {
    return file ? Math.ceil(file.size / FILE_CHUNK_SIZE) : 0;
  }
  static getFileName(file: File): string {
    return file ? file.name : "";
  }
  static getFileSize(file: File): string {
    return file ? `(${formatSize(file.size)})` : "";
  }
  // 1G
  static isOverSize(file: File) {
    return file.size > Math.pow(1024, 3);
  }
  static getVideoDuration(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        resolve(0);
      }, 10000);
      if (!this.isVideo(file)) {
        resolve(0);
      }
      const url = URL.createObjectURL(file);
      let element: any = new Audio(url);
      element.addEventListener("loadedmetadata", () => {
        clearTimeout(timer);
        resolve(element.duration);
        element = null;
      });
    });
  }
  static getFileFormData(data: UploadFormData): FormData {
    const formData = new FormData();
    const {
      fileName,
      fileMd5Code,
      currentChunk,
      totalChunkSize,
      multipartFile,
      videoTime
    } = data;
    formData.append("fileName", fileName);
    formData.append("fileMd5Code", fileMd5Code);
    formData.append("currentChunk", currentChunk.toString());
    formData.append("totalChunkSize", totalChunkSize.toString());
    formData.append("multipartFile", multipartFile);
    videoTime && formData.append("videoTime", videoTime.toString());
    return formData;
  }

  static getSuffix(file: File): string {
    return file.name
      .split(".")
      .slice(-1)[0]
      .toLowerCase();
  }
  static getWareResourceTypeText(wareResourceType): string {
    return {
      [CoursewareResourceType.video]: "视频",
      [CoursewareResourceType.ppt]: "PPT",
      [CoursewareResourceType.pdf]: "PDF"
    }[wareResourceType];
  }
  static isVideo(file: File): boolean {
    if (!file || !file.name) {
      return false;
    }
    const suffix = this.getSuffix(file);
    return suffix == "mp4";
  }
  static isExcel(file: File): boolean {
    if (!file || !file.name) {
      return false;
    }
    const suffix = this.getSuffix(file);
    return suffix == "xls" || suffix == "xlsx";
  }
  static checkFileType(fileList: File[] | File, types: string): boolean {
    if (!Array.isArray(fileList)) {
      fileList = [fileList];
    }
    const typeList = types.replace(/\s/g, "").split(",");
    return fileList.every(file => {
      const fileType =
        "." +
        file.name
          .toLowerCase()
          .split(".")
          .slice(-1)[0];
      return typeList.some(type => fileType == type);
    });
  }
  static async freshImgUrl(content: string) {
    // 匹配到每一张图片
    let regContent;
    let regTag;
    if (content.indexOf("service") > -1) {
      regContent = /<img\s*src="[^"]*?\/service-[^/]*\/.*?\.[^?]*?\??[^>]*"\s*>/g;
      regTag = /src="[^"]*?(\/service-[^/]*\/.*\.[^?>"]*)\??/;
    } else {
      regContent = /<img\s*src="[^"]*?\/[^/]*\/.*?>/g;
      regTag = /src="[^"]*?(\/[^/]*\/.*\.[^?>"]*)\??/;
    }
    const imgMatch = content.match(regContent);
    let newContent = content;
    if (!imgMatch) {
      return newContent;
    }
    // 替换富文本中所有img标签中的url
    for (let i = 0; i < imgMatch.length; i++) {
      const imgTag = imgMatch[i];
      const src: any = imgTag.match(regTag);
      let url = "";
      if (!src) {
        return "";
      }
      if (src[0].indexOf("service") > -1) {
        const arr = src[1].split("service");
        const last = arr.length - 1;
        url = "service" + arr[last];
      } else {
        const Reg = /src=['"]?([^'"]*)['"]?/i;
        url = src[0].match(Reg)[1];
      }
      // 获取新的图片地址
      const res = await GlobalOnlyUploadService.showImg(url);
      // 去掉转义符 后的src
      const replaceVal = `<img src="${res}">`;
      newContent = newContent.replace(imgMatch[i], replaceVal);
    }
    return newContent;
  }
}
